var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFactura(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICONOS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3109 16.6889V6.95976C18.3109 5.70725 17.2925 4.68887 16.04 4.68887H7.45199C6.56318 4.69569 5.84259 5.41856 5.84259 6.30736V7.92585H8.14985V18.7688C8.14985 19.6622 8.87498 20.3873 9.76833 20.3873H19.0087C19.8952 20.3873 20.6181 19.6667 20.6181 18.7779V16.6866H18.3109V16.6889ZM10.4571 18.7688C10.4571 19.1484 10.148 19.4576 9.76833 19.4576C9.38872 19.4576 9.07957 19.1484 9.07957 18.7688V6.30736C9.07957 6.06186 9.02501 5.82773 8.92499 5.61859H16.04C16.7788 5.61859 17.3811 6.22098 17.3811 6.95976V16.6889H10.4571V18.7688ZM19.6884 18.7779C19.6884 19.153 19.3838 19.4576 19.0087 19.4576H11.2322C11.33 19.2484 11.3868 19.0143 11.3868 18.7688V17.6186H19.6884V18.7802V18.7779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.4674 11.6129H10.0002V12.5426H16.4674V11.6129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.4674 9.30338H10.0002V10.2331H16.4674V9.30338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.4674 6.99612H10.0002V7.92585H16.4674V6.99612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.4628 13.9202H10.0002V14.8499H16.4628V13.9202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.7689 0.538086C6.14267 0.538086 0.768921 5.91183 0.768921 12.5381C0.768921 19.1643 6.14267 24.5381 12.7689 24.5381C19.3952 24.5381 24.7689 19.1643 24.7689 12.5381C24.7689 5.91183 19.3974 0.538086 12.7689 0.538086ZM12.7689 23.6152C6.65185 23.6152 1.69182 18.6552 1.69182 12.5381C1.69182 6.42102 6.65185 1.46099 12.7689 1.46099C18.886 1.46099 23.846 6.42102 23.846 12.5381C23.846 18.6552 18.886 23.6152 12.7689 23.6152Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactura);
export default __webpack_public_path__ + "static/media/factura.39f40992a2e181d73e0872586a77f239.svg";
export { ForwardRef as ReactComponent };